import { Stack, Box } from "@mui/material";
import SwitchGradient from "../../assets/figmaexports/switchgradient.png";

const PageSection = (props) => {
  const boxProps = {
    width: "100%",
    height: "100%"
  };
  const stackProps = {
    height: "100%",
    width: "100%",
    direction: "row",
    justifyContent: "center",
    backgroundColor: "#101011"
  };
  const contentBoxProps = {
    // height: '90%',
    width: "80%",
    paddingY: "5%",
    backgroundColor: "#101011",
    // sx: {
    //   backgroundImage: `url(${SwitchGradient})`,
    //   backgroundSize: "100%",
    // },
  };

  return (
    <Box {...boxProps}>
      <Stack {...stackProps}>
        <Box {...contentBoxProps}>{props.children}</Box>
      </Stack>
    </Box>
  );
};

export default PageSection;
